/**
 * API client for Team API Key operations.
 */

import { apiDelete, apiGet, apiPost } from '@/lib/http/client';

export interface TeamApiKey {
  id: string;
  name: string;
  prefix: string;
  created: string;
  created_by: number;
  created_by_email: string;
}

export interface CreateTeamApiKeyRequest {
  name: string;
}

export interface CreateTeamApiKeyResponse {
  id: string;
  name: string;
  prefix: string;
  created: string;
  created_by: number;
  key: string;
}

/**
 * List all Team API Keys for an organization.
 */
export async function listTeamApiKeys(
  orgId: number,
  signal?: AbortSignal
): Promise<TeamApiKey[]> {
  return apiGet<TeamApiKey[]>(
    `/api/orgs/${orgId}/api/team-api-keys/`,
    undefined,
    undefined,
    signal
  );
}

/**
 * Create a new Team API Key for an organization.
 */
export async function createTeamApiKey(
  orgId: number,
  name: string
): Promise<CreateTeamApiKeyResponse> {
  return apiPost<CreateTeamApiKeyResponse>(
    `/api/orgs/${orgId}/api/team-api-keys/`,
    { name }
  );
}

/**
 * Delete a Team API Key.
 */
export async function deleteTeamApiKey(
  orgId: number,
  keyId: string
): Promise<void> {
  await apiDelete<undefined>(
    `/api/orgs/${orgId}/api/team-api-keys/${encodeURIComponent(keyId)}/`
  );
}
